export const KEY_REMEMBER_EMAIL = "haven:rememberEmail";
